import React from 'react';

import { ClearOutlined, DragIndicator } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';

import TooltipIconButton from '@/components/TooltipIconButton';
import { NameInput } from '@/features/Dashboard/components/NameInput';
import { TABNAME_MAX_LENGTH } from '@/features/Dashboard/constants/const';
import MoveTabToDashboardMenu from '@/features/Dashboard/pages/Edit/components/MoveTabToDashboardMenu';

export type EditableTabLabelProps = {
  allowTabReorder: boolean;
  error?: string;
  name: string;
  tabId: string;
  onRename: (tabId: string, value: string) => void;
  onDelete: (tabId: string) => void;
  canDelete: boolean;
  canMove?: boolean;
  onMoved?: (tabId: string) => void;
};

export const EditableTabLabel = ({
  allowTabReorder,
  error,
  name,
  tabId,
  onRename,
  onDelete,
  canDelete,
  canMove = true,
  onMoved
}: EditableTabLabelProps) => {
  const [moveAnchor, setMoveAnchor] = React.useState<HTMLElement | null>(null);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',

        width: 'calc(100% + 16px)',
        mr: '-8px',
        ml: '-8px'
      }}
    >
      {allowTabReorder && (
        <Tooltip title='Drag to reorder tab'>
          <Box
            className='tab-drag-handle'
            sx={{
              width: 16,
              height: 48,
              p: 0,
              borderRadius: 0,
              backgroundColor: 'gx.response',

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'grab'
            }}
          >
            <DragIndicator sx={{ fontSize: '14px' }} />
          </Box>
        </Tooltip>
      )}
      <Box
        data-tab-drag-disabled='true'
        sx={{
          flex: 1,
          maxWidth: '100px',
          width: '100px',
          minWidth: '100px',
          '.MuiInputBase-root': {
            height: '46px'
          }
        }}
      >
        <NameInput
          error={error}
          maxLength={TABNAME_MAX_LENGTH}
          value={name}
          onChange={value => {
            onRename(tabId, value);
          }}
        />
      </Box>
      {/*{canMove && (*/}
      {/*  <TooltipIconButton*/}
      {/*    sx={{ height: 46, mr: '2px' }}*/}
      {/*    title='Move tab to dashboard'*/}
      {/*    onClick={e => {*/}
      {/*      e.stopPropagation();*/}
      {/*      setMoveAnchor(e.currentTarget);*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    <HighlightAltOutlined />*/}
      {/*  </TooltipIconButton>*/}
      {/*)}*/}
      {canDelete && (
        <TooltipIconButton
          sx={{ height: 46 }}
          title='Remove tab'
          onClick={e => {
            e.stopPropagation();
            onDelete(tabId);
          }}
        >
          <ClearOutlined />
        </TooltipIconButton>
      )}
      {canMove && (
        <MoveTabToDashboardMenu
          anchorEl={moveAnchor}
          disableMove={!canMove}
          open={Boolean(moveAnchor)}
          tabId={tabId}
          tabName={name}
          onClose={() => {
            setMoveAnchor(null);
          }}
          onMoved={() => {
            onMoved?.(tabId);
            setMoveAnchor(null);
          }}
        />
      )}
    </Box>
  );
};
